export default __webpack_public_path__ + "static/media/2x2_blue.f14ed4a2.png";